import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Typography,
  SelectChangeEvent,
} from "@mui/material";

interface QuantitySelectorProps {
  quantity: number;
  onQuantityChange: (event: SelectChangeEvent<number>) => void;
  variant?: "mobile" | "desktop";
}

export const QuantitySelector = ({
  quantity,
  onQuantityChange,
  variant = "mobile",
}: QuantitySelectorProps) => {
  const minWidth = variant === "mobile" ? 100 : 120;

  return (
    <Box sx={{ minWidth }}>
      <Typography
        variant="body2"
        sx={{
          fontSize: 11,
          fontWeight: 600,
          color: "text.secondary",
          mb: 0.5,
          textTransform: "uppercase",
          letterSpacing: 0.3,
        }}
      >
        Quantity
      </Typography>
      <FormControl fullWidth>
        <Select
          labelId="quantity-select"
          id="quantity-select"
          value={quantity}
          onChange={onQuantityChange}
          data-cypress="quantity-select"
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              backgroundColor: "white",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#d0d0d0",
              borderWidth: 1.5,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "primary.main",
              borderWidth: 2,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "primary.main",
              borderWidth: 2,
            },
            "& .MuiSelect-select": {
              padding: "8px 12px",
              fontSize: 14,
              fontWeight: 500,
            },
          }}
        >
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
            <MenuItem key={num} value={num}>
              {num}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
